"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconAdlas = function IconAdlas(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9 5h26v32h2V10h2v29h-4v4H14a5 5 0 0 1-5-5zm5 36h19V7H11v31a3 3 0 0 0 2.824 2.995zm16-9v1H14v-1zm0 5v-1H14v1zm-7.83-24.22c-.916 0-1.545 1.483-1.84 3.704-2.076-.86-3.68-1.059-4.138-.264-.46.795.517 2.085 2.301 3.455-1.783 1.369-2.758 2.658-2.299 3.453s2.06.596 4.135-.262c.294 2.227.924 3.714 1.841 3.714.918 0 1.548-1.49 1.842-3.721 2.073.857 3.673 1.055 4.131.26.458-.793-.512-2.078-2.288-3.444 1.778-1.366 2.748-2.653 2.29-3.447s-2.06-.596-4.135.263c-.294-2.225-.923-3.711-1.84-3.711m-1.023 6.308a23 23 0 0 1 1.03-.594 24 24 0 0 1 1.015.587 24 24 0 0 1 0 1.188 23 23 0 0 1-1.015.587 24 24 0 0 1-1.03-.594l-.005-.293-.002-.289q0-.3.007-.592m-1.794 1.21c-1.498 1.114-2.425 2.101-2.293 2.33s1.448-.079 3.16-.818a25 25 0 0 1-.058-.98q-.42-.266-.81-.532m4.767-2.752q.038.469.057.966.427.27.82.54c1.492-1.112 2.414-2.095 2.282-2.324s-1.447.08-3.159.818m-2.822 4.887q.431-.205.879-.44.44.231.865.434c-.216 1.856-.607 3.153-.872 3.153-.264 0-.655-1.294-.872-3.146m2.88-1.596q.426-.27.818-.539c1.492 1.111 2.413 2.093 2.281 2.322-.132.228-1.446-.08-3.156-.817a25 25 0 0 0 .057-.966m-4.015-2.318q-.422.266-.81.533c-1.5-1.115-2.427-2.103-2.295-2.332.132-.23 1.449.08 3.162.819q-.038.475-.057.98m2.878-1.596q-.423.203-.864.434a25 25 0 0 0-.877-.44c.216-1.848.606-3.137.87-3.137s.655 1.292.871 3.143",
    clipRule: "evenodd"
  })));
};

export { IconAdlas, IconAdlas as default };
